module.exports = __webpack_public_path__ + "img/boton_mult_tx.423458e9.svg";